import globals from "../partials/global-variables";
import { ButtonPaginationNextBack, ButtonPagination, ButtonPaginationSelected } from "../partials/buttons";

export default {
  container: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: "5px",
    [`@media (${globals.breakpoints.$xs})`]: {
      textAlign: "center",
      marginBottom: "20px",
      paddingRight: 0,
    },
    "& .selected": {
      ...ButtonPaginationSelected,
    },
    "& .pdf-download-button": {
      display: "none", // hidden by default - it is there for enabling it with custom CSS
      marginRight: "auto",
      marginLeft: 0,
    },
    "& .advice-navigation-button": {
      ...ButtonPagination,
    },
    "& .navigation-next-button, & .navigation-back-button": {
      ...ButtonPaginationNextBack,
    },
  },
};
